if (typeof TrustedBySlider === 'undefined') {
  class TrustedBySlider {
    constructor(element) {
      this.sliderElement = element;
      this.initSlider();
    }

    initSlider() {
      const slider = this.sliderElement.querySelector('.trusted-by__content-item-list');
      const dots = this.sliderElement.querySelector('.trusted-by__content-slider-controls-dots');
      const nextArrow = this.sliderElement.querySelector('.trusted-by__content-slider-controls-arrow--next');
      const prevArrow = this.sliderElement.querySelector('.trusted-by__content-slider-controls-arrow--prev');

      if (slider && !slider.classList.contains('slick-initialized')) {
        $(slider).slick({
          slidesToShow: 2.24,
          slidesToScroll: 1,
          appendDots: dots,
          nextArrow: nextArrow,
          prevArrow: prevArrow,
          dots: true,
          arrows: true,
          infinite: false,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1.092,
                slidesToScroll: 1
              }
            }
          ]
        });
      }
    }
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll('trusted-by-slider').forEach((element) => {
      new TrustedBySlider(element);
    });
  });
}
